import { render } from "./FichesView.vue?vue&type=template&id=2ca6363b"
import script from "./FichesView.vue?vue&type=script&lang=js"
export * from "./FichesView.vue?vue&type=script&lang=js"

import "./FichesView.vue?vue&type=style&index=0&id=2ca6363b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__